import { css, styled } from "goober";
import { mobileLarge } from "clutch/src/Style/style.mjs";

export const TFTScoreLeftBorder = styled("div")`
  width: 4px;
  height: 100%;

  background: var(--yellow);

  opacity: 0;

  ${mobileLarge} {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
`;

export const TFTScoreHighlight = styled("div")`
  position: absolute;
  top: 0;
  left: 0;

  width: 100vw;
  max-width: 479px;
  height: 100%;

  background: linear-gradient(270deg, rgba(239, 191, 108, 0) 0%, #efbf6c 100%);
  opacity: 0;

  z-index: 0;
`;

export const TFTScoreAvatar = styled("div")<{ url?: string }>(({ url }) => ({
  backgroundImage: `url(${url})`,
  backgroundColor: "var(--shade7)",
  backgroundSize: "cover",
  width: "var(--sp-10)",
  height: "var(--sp-10)",
  borderRadius: "100%",
  flexShrink: 0,
  border: "2px solid var(--shade5)",
  backgroundPosition: "40% 0",
}));

export const TFTScorePlacement = styled("p")({
  fontSize: "var(--sp-3)",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
});

export const TFTScoreUsername = styled("p")({
  fontSize: "var(--sp-3_5)",
  fontWeight: "bold",
  whiteSpace: "nowrap",
});

export const cssCurrentProfilePlayer = () => css`
  ${TFTScoreLeftBorder} {
    opacity: 1;
  }

  ${TFTScoreHighlight} {
    opacity: 0.15;
  }

  ${TFTScoreAvatar} {
    border: 2px solid var(--yellow);
  }

  ${TFTScorePlacement} {
    color: var(--yellow);
  }

  ${TFTScoreUsername} {
    color: var(--yellow);
  }
`;

export const TFTScoreContainer = styled("a")`
  display: contents;

  &:not(${cssCurrentProfilePlayer}):hover {
    ${TFTScoreUsername} {
      color: var(--shade2);
    }
    ${TFTScorePlacement} {
      color: var(--shade2);
    }
    ${TFTScoreAvatar} {
      border-color: var(--shade2);
    }
  }

  ${mobileLarge} {
    display: flex;
    flex-direction: column;
    position: relative;
    padding: var(--sp-4) var(--sp-3);
    border-bottom: 1px solid var(--shade6);
  }
`;

export const TFTScoreLink = styled("a")`
  &::after {
    content: "";

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: rgba(0, 0, 0, 0);

    z-index: 1;
  }
`;

export const TFTIconWithText = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "var(--sp-1)",
});

export const TFTScoreProfile = styled("div")`
  display: flex;
  gap: var(--sp-2);
  align-items: center;
  color: var(--shade3);
  width: 100%;
  ${mobileLarge} {
    justify-content: space-between;
  }
`;

export const TFTScoreRank = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "var(--sp-1)",
  svg: {
    flexShrink: 0,
    fontSize: "var(--sp-3)",
  },
});

export const TFTScoreUnits = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "var(--sp-1)",
});

export const TFTScoreTraits = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--sp-30);
  flex-wrap: wrap;
  ${mobileLarge} {
    width: var(--sp-25);
  }
`;

export const TFTUser = styled("div")({});

export const UnitsContainer = styled("div")`
  padding: 0 10%;
  padding-top: var(--sp-4);
`;
